import {
  GetStartDateForPlannerDate,
  OffsetDays,
  getNumberOfDays,
  GetDaysInZoom,
  isWeekend,
} from "../../../lib/DateUtils";
import Api from "../../../Api";
import ReactDOMClient from "react-dom/client";
import TeambookDialog from "../../default_components/TeambookDialog";
import DangerPic from "../../default_images/danger_deletion.svg";
import bookingPrecheckModal from "../../default_components/question_modals/bookingPrecheckModal";

async function MoveBookingRequest(
  date,
  zoom,
  bookings,
  setBookings,
  bookingsEditing,
  teamUsers,
  closeEditWindow,
  teams,
  teamId,
  usersRef,
  filteredUsers,
  hash,
  moveRpetitions = "default",
  t
) {
  const zoomDays = GetDaysInZoom(zoom) + 14;
  const from = GetStartDateForPlannerDate(date, zoom);
  const to = OffsetDays(from, zoomDays);
  const userIdsToUpdateRow = new Set();

  const bookingMovingHash = hash;
  const { booking } = hash;

  const weekendsHidden = !(localStorage.getItem("weekendsHidden") === "false");

  let fromUserIndex = 0;
  let toUserIndex = 0;
  let userIds = [];
  let bookingEditingHash = {};

  if (bookingsEditing.length === 0) {
    bookingsEditing = [booking];
  }

  for (let booking of bookingsEditing) {
    if (bookingEditingHash[booking.user_id]) {
      bookingEditingHash[booking.user_id].push(booking);
    } else {
      bookingEditingHash[booking.user_id] = [booking];
    }
  }

  teamUsers.forEach((user, i) => {
    if (user && user.id && bookingMovingHash.to_user) {
      if (user.id.toString() === bookingMovingHash.from_user.toString()) {
        fromUserIndex = i;
      }

      if (user.id.toString() === bookingMovingHash.to_user?.id.toString()) {
        toUserIndex = i;
      }
    }
  });

  let userIndexOffset = toUserIndex - fromUserIndex;
  let userDateOffset = getNumberOfDays(bookingMovingHash.from_date, bookingMovingHash.to_date);

  Object.keys(bookingEditingHash).forEach((userId) => {
    teamUsers.forEach((user, i) => {
      if (userId.toString() === user.id.toString()) {
        if (!(teamUsers.length <= i + userIndexOffset || 0 > i + userIndexOffset)) {
          for (let j = 0; j < bookingEditingHash[userId].length; j++) {
            userIds.push(teamUsers[i + userIndexOffset].id);
          }
        }
      }
    });
  });

  let currentBookingId = 0;
  const movingData = [];

  for (let userId of Object.keys(bookingEditingHash)) {
    for (let booking of bookingEditingHash[userId]) {
      if (isWeekend(OffsetDays(new Date(booking.date), userDateOffset)) && weekendsHidden && zoom !== 1) {
        userDateOffset += 2;
      }

      movingData.push({
        booking_id: booking.id,
        date: OffsetDays(new Date(booking.date), userDateOffset),
        old_user_id: booking.user_id,
        new_user_id: userIds[currentBookingId],
        grouping_id: booking.grouping_id,
        project_id: booking.project_id,
      });

      userIdsToUpdateRow.add(booking.user_id);
      userIdsToUpdateRow.add(userIds[currentBookingId]);

      currentBookingId++;
    }
  }

  const unchangedBookings = bookings.filter((b) => !Array.from(userIdsToUpdateRow).includes(b.user_id)) || [];

  const precheckData = movingData.map((b) => ({
    user_id: b.new_user_id,
    date: b.date,
    id: b.booking_id,
    project_id: b.project_id,
    grouping_id: b.grouping_id || null,
  }));
  const precheckResult = await bookingPrecheckModal(precheckData, t);

  if (precheckResult === "skip") {
    return [];
  }

  await Api.Bookings.move_bookings(movingData, from, to, moveRpetitions).then((res) => {
    setBookings([...unchangedBookings, ...res.data["bookings"]]);
  });

  hash.updateBookings();
  closeEditWindow();

  return Array.from(userIdsToUpdateRow);
}

export default MoveBookingRequest;
